import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowUpRight } from "lucide-react";

const ITEMS = [
  { label: "Úklid kanceláří v Brně", to: "/uklid-kancelari-brno" },
  { label: "Úklid administrativních budov v Brně", to: "/uklid-kancelari-brno" },
  { label: "Úklid provozoven v Brně", to: "/uklid-provozoven-brno" },
  { label: "Úklid firemních objektů v Brně", to: "/uklid-provozoven-brno" },
  { label: "Úklid společných prostor v Brně", to: "/uklid-bytovych-domu-brno" },
  { label: "Úklid bytových domů v Brně", to: "/uklid-bytovych-domu-brno" },
];

const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative bg-white py-20 md:py-28"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-20">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.28em] font-bold text-[#0F5C69]">
              [ 01 ] — Služby
            </div>
            <h2 className="font-display text-4xl md:text-6xl font-bold tracking-[-0.025em] leading-[1.02] mt-5">
              O co se<br />postaráme.
            </h2>
            <p className="mt-8 max-w-xl text-[#555555] leading-relaxed text-base md:text-lg">
              Specializujeme se na pravidelný úklid kanceláří, firemních
              prostor, provozoven a společných prostor bytových domů v Brně
              a okolí. Každý objekt má jiné nároky, proto navrhujeme
              individuální systém úklidu podle provozu, frekvence využití
              a požadovaného standardu čistoty.
            </p>

            <Link
              to="/uklid-kancelari-brno"
              data-testid="services-detail-link"
              className="mt-8 inline-flex items-center gap-2 text-sm font-semibold text-[#0F5C69] hover:gap-3 transition-all"
            >
              Více o úklidu kanceláří v Brně
              <ArrowUpRight size={16} strokeWidth={2.5} />
            </Link>

            <div
              data-testid="services-why-block"
              className="mt-12 pt-10 border-t border-[#E5E5E5]"
            >
              <div className="text-xs uppercase tracking-[0.28em] font-bold text-[#0F5C69]">
                Proč Sanvioro
              </div>
              <ul className="mt-6 space-y-4">
                {[
                  "Proškolený tým podle jasně daného standardu",
                  "Jeden kontaktní manažer po celou dobu spolupráce",
                  "Individuální harmonogram podle provozu objektu",
                  "Fakturace na firmu, bez skrytých poplatků",
                ].map((item, i) => (
                  <li
                    key={item}
                    data-testid={`why-sanvioro-${i}`}
                    className="flex items-start gap-3"
                  >
                    <Check
                      size={20}
                      strokeWidth={2.5}
                      className="text-[#0F5C69] shrink-0 mt-0.5"
                    />
                    <span className="text-[#222222] leading-relaxed text-base md:text-lg">
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lg:col-span-5 lg:pl-8 lg:border-l border-[#E5E5E5] flex flex-col justify-center">
            <div className="text-xs uppercase tracking-[0.28em] font-bold text-[#0F5C69] mb-6">
              Uklízíme
            </div>
            <ul className="divide-y divide-[#E5E5E5] border-y border-[#E5E5E5]">
              {ITEMS.map((it, i) => {
                const inner = (
                  <>
                    <Check
                      size={20}
                      strokeWidth={2.5}
                      className="text-[#0F5C69] shrink-0"
                    />
                    <span className="font-display text-2xl md:text-3xl font-semibold tracking-tight text-[#111111] group-hover:text-[#0F5C69] transition-colors">
                      {it.label}
                    </span>
                    {it.to && (
                      <ArrowUpRight
                        size={18}
                        strokeWidth={2.5}
                        className="ml-auto text-[#0F5C69]/60 group-hover:text-[#0F5C69] transition-colors"
                      />
                    )}
                  </>
                );
                return (
                  <li
                    key={it.label}
                    data-testid={`service-item-${i}`}
                    className="group"
                  >
                    {it.to ? (
                      <Link
                        to={it.to}
                        className="flex items-center gap-5 py-5 transition-colors hover:text-[#0F5C69]"
                      >
                        {inner}
                      </Link>
                    ) : (
                      <div className="flex items-center gap-5 py-5 transition-colors hover:text-[#0F5C69]">
                        {inner}
                      </div>
                    )}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
